import React from 'react'
import { useUserHasScopedBlockAccess } from '../../../../components/ScopedBlock/hooks'
import { BrandColorSelect } from '../../../Scheduling/shared/BrandColorSelect'
import { BRANDING_ACCOUNT_SCOPE } from './brandingConstants'

interface BrandColorSectionProps {
  brandColor: string
  disabled: boolean
  onSave: (brandColor: string) => void
}

export const BrandColorSection: React.FC<BrandColorSectionProps> = ({ brandColor, disabled, onSave }) => {
  const { userHasScopedBlockAccess } = useUserHasScopedBlockAccess()
  const [canEdit] = userHasScopedBlockAccess([], undefined, BRANDING_ACCOUNT_SCOPE)

  return (
    <div className='d-flex flex-column zocks-gap-1'>
      <div className='d-flex flex-column'>
        <h6 className='zocks-text-gray-900'>Brand color</h6>
        <p className='paragraph-small zocks-text-gray-700 m-0'>Used for buttons and links on client-facing pages.</p>
      </div>
      <div className='d-flex align-self-start'>
        <BrandColorSelect value={brandColor} readOnly={disabled || !canEdit} onChange={onSave} />
      </div>
    </div>
  )
}
